import { DEFAULT_FUZZY_SETTINGS, type FuzzySearchSettings } from './settingsSchema';

export const STORAGE_KEY = 'gxgo:catalog-fuzzy-search-settings';

/** Read + merge persisted overrides over the defaults; never throws. */
export function loadSettings(): FuzzySearchSettings {
  try {
    if (typeof localStorage === 'undefined') return DEFAULT_FUZZY_SETTINGS;
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULT_FUZZY_SETTINGS;
    const parsed = JSON.parse(raw) as Partial<FuzzySearchSettings>;
    return { ...DEFAULT_FUZZY_SETTINGS, ...parsed };
  } catch {
    return DEFAULT_FUZZY_SETTINGS;
  }
}

let snapshot: FuzzySearchSettings = loadSettings();
const listeners = new Set<() => void>();

function emit(): void {
  for (const listener of listeners) listener();
}

export function getSnapshot(): FuzzySearchSettings {
  return snapshot;
}

export function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function setOption<K extends keyof FuzzySearchSettings>(
  key: K,
  value: FuzzySearchSettings[K]
): void {
  snapshot = { ...snapshot, [key]: value };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(snapshot));
  } catch {
    /* persistence is best-effort */
  }
  emit();
}

export function reset(): void {
  snapshot = DEFAULT_FUZZY_SETTINGS;
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
  emit();
}
